import styles from './NavigationItem.module.scss';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { MouseEvent } from 'react';
import { useBreakpoint, useLeftPanelActions } from 'src/hooks';
import { SVG_SIZE_M } from 'src/constants';
import { LockSimple } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';

type NavigationItemProps = {
  item: {
    disabled: boolean;
    route: string;
    title: string;
    icon: JSX.Element;
    isVisible: boolean;
    additionalActivePaths?: string[];
  };
};

export const NavigationItem = ({ item }: NavigationItemProps) => {
  const { isMobileOrTablet } = useBreakpoint();
  const { toggleLeftPanelExpanded } = useLeftPanelActions();
  const location = useLocation();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (item.disabled) {
      e.preventDefault();
      return;
    }
    if (isMobileOrTablet) {
      toggleLeftPanelExpanded(false);
    }
  };

  if (!item.isVisible) {
    return null;
  }

  return (
    <Button
      as="link"
      className={classNames(styles.menuLink, {
        active:
          item.route === location.pathname ||
          (!!item.additionalActivePaths &&
            item.additionalActivePaths.includes(location.pathname)),
        disabled: item.disabled,
      })}
      to={item.route}
      onClick={handleClick}
      color="transparent"
    >
      <>
        {item.disabled ? <LockSimple size={SVG_SIZE_M} /> : item.icon}
        <span>{item.title}</span>
      </>
    </Button>
  );
};
